<template>
    <div class="col-md-12">
        <div class="row my-3">
            <div class="col-md-8">
                <div class="h2">Bookings</div>
            </div>
            <div class="col-md-4">
                <a href="/bookings/create"
                   class="btn btn-success float-right d-flex align-items-center"
                   title="Create booking">
                    <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                    <span>Create Booking</span>
                </a>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-md-6">

            </div>

            <div class="col-md-2">
                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                    <select
                        v-model="filters.dateType"
                        class="form-control">
                        <option value='1'>Creation</option>
                        <option value='2'>Pick-up</option>
                        <option value='3'>Drop-off</option>
                    </select>
                </div>
            </div>

            <div class="col-md-2">
                <div
                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                    <date-picker v-model="filters.dateFrom"
                                 valueType="YYYY-MM-DD"
                                 input-class="border-0 py-0 shadow-none form-input"
                                 placeholder="from"
                                 :lang="datePickerOptions.lang"
                                 format="DD/MM/YYYY">
                    </date-picker>
                </div>
            </div>

            <div class="col-md-2">
                <div
                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                    <date-picker v-model="filters.dateTo"
                                 valueType="YYYY-MM-DD"
                                 input-class="border-0 py-0 shadow-none form-input"
                                 placeholder="to"
                                 :lang="datePickerOptions.lang"
                                 format="DD/MM/YYYY">
                    </date-picker>
                </div>
            </div>
        </div>
        <div class="position-relative pagination-control table-hover">
            <data-table
                :columns="columns"
                :url="tableUrl"
                :per-page="perPage"
                :order-by="orderBy"
                :order-dir="orderDir"
                :meta="columns.meta"
                :classes="classes"
                :translate="translate"
                :filters="filters"
                :debounce-delay=1000
                ref="table"
                @finished-loading="tableLoaded"
            >
                <div slot="filters" slot-scope="{ tableFilters, perPage, bookings }">
                    <div class="row my-3">
                        <div class="col-md-4">
                            <div
                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                    <span class="material-icons-outlined cursor-pointer">search</span>
                                </button>
                                <input name="name" v-model="filters.search"
                                       class="form-control border-0 py-0 pl-0 shadow-none form-input"
                                       placeholder="Search"/>
                            </div>
                        </div>
                        <div class="col-md-8 d-flex justify-content-end align-items-center">
                            <div class="btn-group float-right shadow-sm" role="group" aria-label="">
                                <button @click="isActive(0)" type="button" class="btn border-left px-3 py-2"
                                        :class="status===0? 'btn-primary':'bg-white'">All
                                </button>
                                <button @click=isActive(1) type="button" class="btn border-left"
                                        :class="status===1? 'btn-primary':'bg-white'">
                                                    <span class="position-relative pr-2">New
                                                       <span class="badge rounded-circle position-absolute number-quote"
                                                             :class="status===1? 'badge-light':'badge-primary'">
                                                            {{ notSeenNumber }}
                                                       </span>
                                                     </span>
                                </button>
                                <button @click=isActive(2) type="button" class="btn border-left px-3"
                                        :class="status===2? 'btn-primary':'bg-white'">Confirmed
                                </button>
                                <button @click=isActive(3) type="button" class="btn border-left px-3"
                                        :class="status===3? 'btn-primary':'bg-white'">Awaiting pickup
                                </button>
                                <button @click=isActive(5) type="button" class="btn border-left px-3"
                                        :class="status===5? 'btn-primary':'bg-white'">On pickup
                                </button>
                                <button @click=isActive(6) type="button" class="btn border-left px-3"
                                        :class="status===6? 'btn-primary':'bg-white'">Awaiting linehaul
                                </button>
                                <button @click=isActive(7) type="button" class="btn border-left px-3"
                                        :class="status===7? 'btn-primary':'bg-white'">Ready for delivery
                                </button>
                                <button @click=isActive(9) type="button" class="btn border-left px-3"
                                        :class="status===9? 'btn-primary':'bg-white'">On dropoff
                                </button>
                                <button @click=isActive(10) type="button" class="btn border-left px-3"
                                        :class="status===10? 'btn-primary':'bg-white'">

                                    <span class="position-relative pr-2">Delivered
                                                       <span class="badge rounded-circle position-absolute number-quote"
                                                             :class="status===10? 'badge-light':'badge-primary'">
                                                            {{ nullHoursCount }}
                                                       </span>
                                                     </span>
                                </button>
                                <button @click=isActive(11) type="button" class="btn border-left px-3"
                                        :class="status === 11? 'btn-primary':'bg-white'">Failed
                                </button>
                                <button @click=isActive(12) type="button" class="btn border-left px-3"
                                        :class="status === 12? 'btn-primary':'bg-white'">Rejected
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <thead class="clickable-header" slot="header" slot-scope="{ tableFilters }">
                <tr>
                    <th>
                    </th>
                    <th @click="sort(column.id)" v-if="column.label!=='' && column.visible===true"
                        v-for="column in columns">
                        <span> {{ column.label }}  </span>
                    </th>
                </tr>
                </thead>
                <tbody slot="body" slot-scope="{ data }">
                <tr class="link-row"
                    :class="item.markAsNullHoursService || item.markAsNullHoursProduct? 'mark-as-null-hours' : ''"
                    :key="item.id"
                    v-for="item in data">
                    <td v-if="column.visible===true"
                        :key="column.name"
                        v-for="column in columns"
                        class="laravel-vue-datatable-td border-0 text-left py-2 font-weight-normal"
                    >
                        <data-table-cell
                            :value="item"
                            :name="column.name"
                            :meta="column.meta"
                            :comp="column.component"
                            :classes="column.classes">
                        </data-table-cell>

                        <slot v-if="column.label === ''">
                            <input type="checkbox"
                                   v-model="bookings[item.id]"
                            >
                        </slot>

                        <slot v-if="column.label === 'Id'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                B-{{ item.id }}
                                <span v-if="role !== 'user'">
                                         - {{ item.client }}
                                </span>
                                <span v-if="item.recurring_data">
                                          ({{ item.recurring_data.name }})
                                </span>
                            </a>
                            <div v-if="item.original_booking_id">
                                B-{{ item.original_booking_id }}-{{ item.copy }}
                            </div>
                        </slot>
                        <slot v-if="column.label === 'Status'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                {{ item.status }}
                            </a>
                        </slot>
                        <slot v-if="column.label === 'Date'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                {{ item.created_at }}
                            </a>
                        </slot>
                        <slot v-if="column.label === 'Address'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                {{ item.dropoff_address.name }},
                                {{ item.dropoff_address.street }},
                                {{ item.dropoff_address.zip }},
                                {{ item.dropoff_address.city }}
                            </a>
                        </slot>
                        <slot v-if="column.label === 'Dropoff'">
                            <div v-if="item.dropoff_date">
                                <span class="mr-1">{{ formatDate(item.dropoff_date) }}</span>
                                <span v-if="item.dropoff_start">{{ item.dropoff_start }}</span>
                            </div>
                        </slot>
                        <slot v-if="column.label === 'Type'">
                            <div>{{ types[item.type] }}</div>
                        </slot>
                        <slot v-if="column.label === 'Weight'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                {{ item.weight|number }}
                            </a>
                        </slot>
                        <slot v-if="column.label === 'Volume'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                {{ item.volume|number }}
                            </a>
                        </slot>
                        <slot v-if="column.label === 'Colli'">
                            <a :href="`/bookings/${item.id}/edit`" class="invisible-link">
                                {{ item.colli }}
                            </a>
                        </slot>
                    </td>
                </tr>
                </tbody>

                <div slot="pagination" slot-scope="{ links, meta }"
                     class="d-flex justify-content-between align-items-center"
                >
                    <div>
                        <label class="pr-2">Bookings per page:</label>
                        <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                            <select class="form-control bg-white border-0 py-0 shadow-none " v-model="filters.length"
                                    style="width: 150px;">
                                <option
                                    :key="index"
                                    :value="records"
                                    v-for="(records, index) in perPage">
                                    {{ records }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <pagination
                        ref="pagination"
                        :total-pages="meta.last_page"
                        :current-page-prop="meta.current_page"
                        v-if="meta && meta.last_page > 1"
                    ></pagination>
                </div>
            </data-table>
            <div class="d-flex justify-content-between mt-3">
                <div>
                    <div @click="printLabels()"
                         class="btn btn-success d-flex align-items-center float-left"
                         title="Print label(s)">
                        <span class="">Print label(s)</span>
                    </div>
                </div>
            </div>
        </div>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import dateTimeMixin from "../mixins/dateTimeMixin";
import Pagination from "./reusable/Pagination.vue";
import dataTablePaginationMixin from "../mixins/dataTablePaginationMixin";
import urlMixin from "../mixins/urlMixin";
import printLabelsMixin from "../mixins/printLabelsMixin";

export default {
    components: {Loading, Pagination},
    mixins: [datePickerOptionsMixin, dateTimeMixin, dataTablePaginationMixin, urlMixin, printLabelsMixin],
    name: "BookingDataTable",
    props: {
        url: {type: String, required: true},
        role: {type: String, required: true},
        types: {type: Object, required: true}
    },
    computed: {
        currentPage() {
            return this.$refs.table.tableData.meta ? this.$refs.table.tableData.meta.current_page : 1;
        },
    },
    data() {
        return {
            tableUrl: this.url,
            isLoading: true,
            perPage: [25, 10, 50, 100],
            orderBy: "id",
            orderDir: "desc",
            columns: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Id',
                    id: 'id',
                    orderable: true,
                    visible: true,
                },
                {
                    label: 'Address',
                    id: 'address',
                    orderable: true,
                    visible: this.role === 'user'
                },
                {
                    label: 'Status',
                    // name: 'status',
                    id: 'status',
                    orderable: true,
                    visible: true,
                },
                {
                    label: 'Date',
                    id: 'created_at',
                    orderable: true,
                    visible: true,
                },
                {
                    label: 'Address',
                    id: 'address',
                    orderable: true,
                    visible: this.role !== 'user'
                },
                {
                    label: 'Reference',
                    name: 'reference',
                    id: 'reference',
                    orderable: true,
                    visible: this.role === 'user'
                },
                {
                    label: 'Dropoff',
                    id: 'dropoff_start',
                    orderable: true,
                    visible: true
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: true,
                    visible: true
                },
                {
                    label: 'Volume',
                    id: 'total_volume',
                    orderable: true,
                    visible: true,
                },
                {
                    label: 'Weight',
                    id: 'total_weight',
                    orderable: true,
                    visible: true,
                },
                {
                    label: 'Colli',
                    // name: 'colli',
                    id: 'colli',
                    orderable: true,
                    visible: true,
                },
            ],
            filters: {
                search: '',
                activeStatus: 0,
                length: 25,
                column: 'id',
                dir: 'desc',
                dateType: 3,
                dateFrom: '',
                dateTo: ''
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,

                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search for ID'
            },
            bookings: {},
            status: 0,
            search: '',
            notSeenNumber: 0,
            nullHoursCount: 0,
            loading: false,
        }
    },
    watch: {
        filters: {
            handler: function(newValue) {
                if (this.$refs.pagination) {
                    this.$refs.pagination.changePage('', 1);
                }
            },
            deep: true
        }
    },
    methods: {
        sort(key) {
            if (key) {
                this.filters.column = key;
                this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
            }
        },
        fetchData() {
            axios.get(`/booking-statuses-counter/${this.role}`)
                .then(({data}) => {
                    this.notSeenNumber = data;
                }).catch();
            axios.get(`/booking-null-hours-counter/${this.role}`)
                .then(({data}) => {
                    this.nullHoursCount = data;
                }).catch();
        },
        isActive(value) {
            this.status = value;
            this.filters.activeStatus = value;
        },
        tableLoaded() {
            let str = this.formatUrlSearchString();
            sessionStorage.setItem('bookingsSearchString', str);
        }
    },
    mounted() {
        this.$refs.table.$on("finished-loading", () => {
            this.isLoading = false;
        });

        this.$refs.table.$on("loading", () => {
            this.isLoading = true;
        });

        this.applyUrlSearch('bookingsSearchString', 'applyBookingsSearchString');
    },
    created() {
        this.fetchData();
    },
    filters: {
        number: function (value) {
            return value.toLocaleString('da-DK');
        }
    },
}
</script>
<style>
.clickable-header {
    cursor: pointer;
}

.invisible-link {
    color: black;
}

.invisible-link:hover {
    text-decoration: none;
}

.invisible-link {
    display: block !important;
    vertical-align: middle;
}

.mark-as-null-hours {
    background-color: #ff00005e !important;
}
</style>
